<template>
  <div class="titlebox boxsizing">
    <div class="title">
      <i :class="'fa font18 grayccc icon ' + (icon ? icon : 'fa-pie-chart')"></i>
      <span class="font16 gray66">{{title}}</span>
      <el-tooltip class="item" effect="dark" :content="tooltip" v-if="tooltip" placement="top">
        <i class="el-icon-question tooltip-icon"></i>
      </el-tooltip>
    </div>
    <div class="title-right">
      <slot>
        <a :href="link" v-if="link" class="blue">更多>></a>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PageTitle',
  props: [
    'icon',
    'title',
    'tooltip',
    'link'
  ],
  data () {
    return {

    }
  },
  methods: {},
  created () {
  }
}
</script>
<style scoped>
/* .title {
  color: blue;
} */
.titlebox {
  height: 40px;
  width: 100%;
  line-height: 40px;
}
.title {
  float: left;
}
.title i.icon {
  margin-right: 15px;
}
.title-right {
  float: right;
}
</style>
